import { jsxs as s, jsx as t } from "react/jsx-runtime";
const e = ({
  color: r,
  ...o
}) => /* @__PURE__ */ s(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "rgb(var(--fill-primary))",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ...o,
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M16.4318 11.1942L15.7998 9.93011C15.5859 9.50228 15.4789 9.28837 15.336 9.103C15.2092 8.93852 15.0618 8.79106 14.8973 8.66427C14.7119 8.52138 14.498 8.41442 14.0702 8.20051L12.8061 7.56845L14.0702 6.93639C14.498 6.72248 14.7119 6.61552 14.8973 6.47263C15.0618 6.34584 15.2092 6.19838 15.336 6.0339C15.4789 5.84853 15.5859 5.63461 15.7998 5.20679L16.4318 3.94267L17.0639 5.20679C17.2778 5.63461 17.3848 5.84853 17.5277 6.0339C17.6544 6.19838 17.8019 6.34584 17.9664 6.47263C18.1518 6.61552 18.3657 6.72248 18.7935 6.93639L20.0576 7.56845L18.7935 8.20051C18.3657 8.41442 18.1518 8.52138 17.9664 8.66427C17.8019 8.79106 17.6544 8.93852 17.5277 9.103C17.3848 9.28837 17.2778 9.50228 17.0639 9.93011L16.4318 11.1942Z",
          fill: r || "url(#stars01_gradient_a)"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M9.58314 20.0573L8.63349 17.5882C8.40626 16.9974 8.29265 16.702 8.11597 16.4535C7.95939 16.2333 7.76699 16.0409 7.54677 15.8843C7.2983 15.7076 7.00291 15.594 6.41213 15.3668L3.94303 14.4171L6.41212 13.4675C7.00291 13.2403 7.2983 13.1267 7.54677 12.95C7.76699 12.7934 7.95939 12.601 8.11597 12.3808C8.29265 12.1323 8.40626 11.8369 8.63349 11.2461L9.58314 8.77704L10.5328 11.2461C10.76 11.8369 10.8736 12.1323 11.0503 12.3808C11.2069 12.601 11.3993 12.7934 11.6195 12.95C11.868 13.1267 12.1634 13.2403 12.7542 13.4675L15.2232 14.4171L12.7542 15.3668C12.1634 15.594 11.868 15.7076 11.6195 15.8843C11.3993 16.0409 11.2069 16.2333 11.0503 16.4535C10.8736 16.702 10.76 16.9974 10.5328 17.5882L9.58314 20.0573Z",
          fill: r || "url(#stars01_gradient_b)"
        }
      ),
      /* @__PURE__ */ s("defs", { children: [
        /* @__PURE__ */ s(
          "linearGradient",
          {
            id: "stars01_gradient_a",
            x1: "19.5433",
            y1: "17.9585",
            x2: "3.4648",
            y2: "10.3147",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ t("stop", { stopColor: "#4EB2F4" }),
              /* @__PURE__ */ t("stop", { offset: "0.211538", stopColor: "#4076F9" }),
              /* @__PURE__ */ t("stop", { offset: "0.769231", stopColor: "#7A3ADB" })
            ]
          }
        ),
        /* @__PURE__ */ s(
          "linearGradient",
          {
            id: "stars01_gradient_b",
            x1: "19.5433",
            y1: "17.9585",
            x2: "3.4648",
            y2: "10.3147",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ t("stop", { stopColor: "#4EB2F4" }),
              /* @__PURE__ */ t("stop", { offset: "0.211538", stopColor: "#4076F9" }),
              /* @__PURE__ */ t("stop", { offset: "0.769231", stopColor: "#7A3ADB" })
            ]
          }
        )
      ] })
    ]
  }
);
e.displayName = "StarsIcon";
export {
  e as StarsIcon
};
